import ToolTip from './Tooltip';

export default ToolTip;


// WEBPACK FOOTER //
// ./src/Components/Tooltip/index.tsx